let shouldTriggerPageViewed = true;
const analyticsUA = {
  ge: 'UA-296593-9',
  sportv: 'UA-16233545-1',
};

/**
 * @param {boolean} isMobile Dispositivo
 * @param {number} windowHeight Altura do dispositivo
 * @return {number}
 */
function getTriggerPoint(isMobile, windowHeight) {
  let positionFromFooter;
  if (isMobile) {
    positionFromFooter = 65;
  } else {
    positionFromFooter = 80;
  }
  return $(document).height() - windowHeight - positionFromFooter;
}

export default class Analytics {
  static init(bucket = 'ge') {
    ga('create', analyticsUA[bucket], 'auto'); // eslint-disable-line
    $('.social-icons-icon').on('click', Analytics.socialShare);
  }

  static socialShare(social) {
    const socialSite = $($(social.currentTarget)[0]).attr('data-social');
    if (window.ga && ga.loaded) { // eslint-disable-line
      ga('send', 'event', 'compartilhamento', socialSite, location.href); // eslint-disable-line
    }
  }

  static eventAnalytics(action, label) {
    const gaObjectExists = window.ga && ga.loaded;
    if (gaObjectExists) {
      ga('send', 'event', 'metricas-interacao', action, label);
    }
  }

  // OBS: Apenas 1 disparo por seção
  static pageViewed() {
    const $window = $(window);
    const isMobile = $window.width() < 768;
    const triggerPoint = getTriggerPoint(isMobile, $window.height());

    if (triggerPoint < $window.scrollTop() && shouldTriggerPageViewed) {
      Analytics.eventAnalytics('fim-pagina', 'pagina-lida');
      shouldTriggerPageViewed = false;
    }
  }
}



// WEBPACK FOOTER //
// local_static/templates/guias/2018/assets/scripts/analytics.js